const t = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Match Icon</title><desc>A picture depicting two puzzle pieces fitting together.</desc><path d="M10 8a3.909 3.909 0 011 .13V6H0v12h3.779a3 3 0 104.442 0H11v-2.13a3.909 3.909 0 01-1 .13 4 4 0 010-8z"/><path d="M24 6h-3.779a3 3 0 10-4.442 0H12v3.779a3 3 0 100 4.442V18h3.779a3 3 0 104.442 0H24z"/></svg>';
export {
  t as default
};
